import { useAccessPattern } from "@hooks/useAccessPattern";
import { useLocation } from "react-router";

interface RenderProps {
  pathname: string;
  isInternalAgent: boolean;
  isSugAgent: boolean;
}

interface AccessPatternProviderProps {
  children: React.ReactNode | ((props: RenderProps) => React.ReactNode);
}

const AccessPatternProvider = ({ children }: AccessPatternProviderProps) => {
  const { pathname } = useLocation();
  const { isInternalAgent, isSugAgent } = useAccessPattern();

  return typeof children === "function"
    ? children({
        isInternalAgent,
        isSugAgent,
        pathname,
      })
    : children;
};

export default AccessPatternProvider;
